/* Card badge fitter — keeps left+right badges on ONE line.
   User rule (2026-07-05): the LEFT badge (dose / pack weight) never shrinks —
   it is the key characteristic. When the pair would touch, the RIGHT badge
   (count "20 cubes" / promo) steps its font down until the row fits. */
(function () {
  var MIN_FONT = 9;
  var GAP = 5; // required clearance between badges, px

  function fitRow(row) {
    var badges = row.querySelectorAll('.upc__badge');
    if (badges.length < 2) return;
    var left = badges[0];
    var right = badges[badges.length - 1];

    // reset previous shrink (resize back up)
    right.style.fontSize = '';
    right.querySelectorAll('.upc__badge-sm, .upc__badge-lg').forEach(function (s) { s.style.fontSize = ''; });
    var ico = right.querySelector('.upc__badge-ico');
    if (ico) { ico.style.width = ''; ico.style.height = ''; }

    var overlapping = function () {
      return left.getBoundingClientRect().right + GAP > right.getBoundingClientRect().left;
    };
    if (!overlapping()) return;

    var probe = right.querySelector('.upc__badge-sm') || right;
    var size = parseFloat(window.getComputedStyle(probe).fontSize);
    var guard = 16;
    while (overlapping() && size > MIN_FONT && guard--) {
      size -= 1;
      right.style.fontSize = size + 'px';
      right.querySelectorAll('.upc__badge-sm, .upc__badge-lg').forEach(function (s) { s.style.fontSize = size + 'px'; });
      if (ico) { ico.style.width = Math.max(10, size - 1) + 'px'; ico.style.height = Math.max(10, size - 1) + 'px'; }
    }
  }

  function fitAll() {
    document.querySelectorAll('.upc__badge-row').forEach(fitRow);
  }

  var t;
  function debouncedFit() { clearTimeout(t); t = setTimeout(fitAll, 120); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fitAll);
  } else {
    fitAll();
  }
  window.addEventListener('load', fitAll);
  window.addEventListener('resize', debouncedFit);
})();
